import React, { useState, useEffect } from "react";

//antd
import { Input, Tooltip, Radio, Empty, Button } from "antd";
import { MenuFoldOutlined, MinusCircleOutlined } from "@ant-design/icons";

//components
import { TitleDivider } from "../../TitleDivider";
import { FinanceSelectMenu } from "./";
import { InputPopout } from "../InputPopout";
import { DCWireWrapper } from "./styles";

import ReactDataSheet from "react-datasheet";
import { renderSheet } from "../SheetRenderer";

//redux
import { useSelector, useDispatch } from "react-redux";
import { inputsActions, isNumber } from "../../Redux";

const formatCurrency = (value) => {
  if (value === "" || isNaN(value)) return "";
  return Number(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const FinanceInstallCosts = ({ expand }) => {
  const dispatch = useDispatch();

  // Store values
  const account_loading = useSelector((state) => state.user.getting_user_data);
  const input_loading = useSelector((state) => state.sift.ioManager.uiState.input_loading);
  const rack_a_not_active = useSelector((state) => state.inputs.racks[0].active == 0);
  const rack_b_not_active = useSelector((state) => state.inputs.racks[1].active == 0);
  const rack_c_not_active = useSelector((state) => state.inputs.racks[2].active == 0);
  const doCustomSchedule = useSelector((state) => state.inputs.do_custom_schedule);
  // const finance = useSelector((state) => state.sift.ioManager.inputs.finance);
  const inputs = useSelector((state) => state.inputs);
  const do_finance = useSelector((state) => state.inputs.do_finance);

  //shared inputs between summarized and detailed

  const toggle_finance_type = useSelector((state) => state.inputs.toggle_finance_type);
  // summarized
  const summarized_dc = useSelector((state) => state.inputs.summarized_dc);
  // const summarized_dc_wiring_gcr = useSelector((state) => state.inputs.summarized_dc_wiring_gcr);
  // const summarized_dc_wiring_wp = useSelector((state) => state.inputs.summarized_dc_wiring_wp);
  const summarized_ac = useSelector((state) => state.inputs.summarized_ac);
  const foot_print = useSelector((state) => state.inputs.foot_print);
  const fixed_cost = useSelector((state) => state.inputs.fixed_cost);
  const metric = useSelector((state) => state.inputs.metric);

  // detailed
  const module_dc_cost = useSelector((state) => state.inputs.module_dc_cost);
  const rack_a_finance = useSelector((state) => state.inputs.rack_a_finance);
  const rack_b_finance = useSelector((state) => state.inputs.rack_b_finance);
  const rack_c_finance = useSelector((state) => state.inputs.rack_c_finance);
  const bos_other = useSelector((state) => state.inputs.bos_other);
  const inverter_cost = useSelector((state) => state.inputs.inverter_cost);
  const ac_aux = useSelector((state) => state.inputs.ac_aux);
  const mv_wire = useSelector((state) => state.inputs.mv_wire);
  const other_ac = useSelector((state) => state.inputs.other_ac);
  const interconnection = useSelector((state) => state.inputs.interconnection);
  const permits_fees = useSelector((state) => state.inputs.permits_fees);
  const engineering = useSelector((state) => state.inputs.engineering);
  const margin = useSelector((state) => state.inputs.margin);
  const itc_ineligible = useSelector((state) => state.inputs.itc_ineligible);

  const other_fixed = useSelector((state) => state.inputs.other_fixed);
  const rack_footprint = useSelector((state) => state.inputs.rack_footprint);
  const boundary_area_per = useSelector((state) => state.inputs.boundary_area_per);
  const contingency = useSelector((state) => state.inputs.contingency);
  const spacing_gcr = useSelector((state) => state.inputs.spacing_gcr);
  const spacing_per_wp = useSelector((state) => state.inputs.spacing_per_wp);

  // menu toggles
  const [toggle_install_costs, set_toggle_install_costs] = useState(false);
  const [toggle_dc_units, set_toggle_dc_units] = useState(false);
  const [toggle_ac_units, set_toggle_ac_units] = useState(false);
  const [toggle_fixed_cost, set_toggle_fixed_cost] = useState(false);
  const [toggle_misc_cost, set_toggle_misc_cost] = useState(false);
  const [toggle_dc_wire, set_toggle_dc_wire] = useState(false);
  const [popoutY, setPopoutY] = useState(0);

  useEffect(() => {
    if (expand) {
      set_toggle_install_costs(true);
      set_toggle_dc_units(true);
      set_toggle_ac_units(true);
      set_toggle_fixed_cost(true);
      set_toggle_misc_cost(true);
      set_toggle_dc_wire(true);
    } else {
      set_toggle_install_costs(false);
      set_toggle_dc_units(false);
      set_toggle_ac_units(false);
      set_toggle_fixed_cost(false);
      set_toggle_misc_cost(false);
      set_toggle_dc_wire(false);
    }
  }, [expand]);

  // input values used for updating inputs
  const [summarizedDC, setSummarizedDC] = useState(summarized_dc);
  const [summarizedAC, setSummarizedAC] = useState(summarized_ac);
  const [footPrint, setFootPrint] = useState(foot_print);
  const [fixedCost, setFixedCost] = useState(fixed_cost);
  const [moduleDCCost, setModuleDCCost] = useState(module_dc_cost);
  const [rackA, setRackA] = useState(rack_a_finance);
  const [rackB, setRackB] = useState(rack_b_finance);
  const [rackC, setRackC] = useState(rack_c_finance);
  const [bosOther, setBosOther] = useState(bos_other);
  const [inverterInput, setInverterInput] = useState(inverter_cost);
  const [acAux, setAcAux] = useState(ac_aux);
  const [mvWire, setMvWire] = useState(mv_wire);
  const [otherAC, setOtherAC] = useState(other_ac);
  const [interconnectionInput, setInterconnectionInput] = useState(interconnection);
  const [permitsFees, setPermitsFees] = useState(permits_fees);
  const [engineeringInput, setEngineeringInput] = useState(engineering);
  const [marginInput, setMarginInput] = useState(margin);
  const [itcIneligible, setitcIneligible] = useState(itc_ineligible);
  const [otherFixed, setOtherFixed] = useState(other_fixed);
  const [rackFootprint, setRackFootprint] = useState(rack_footprint);
  const [boundaryArea, setBoundaryArea] = useState(boundary_area_per);
  const [contingencyInput, setContingencyInput] = useState(contingency);
  const [active_rack_total, set_active_rack_total] = useState(0);

  const [isEditing, setIsEditing] = useState({ id: undefined, editing: false });

  const isEditing_ref = React.useRef(isEditing);

  useEffect(() => {
    isEditing_ref.current = isEditing;
  }, [isEditing]);

  // Update local state when the specific redux input changes. Avoid using a single [inputs] dependency
  // because that can overwrite a field the user is actively editing when unrelated inputs change.
  useEffect(() => {
    setSummarizedDC(summarized_dc);
  }, [summarized_dc]);

  useEffect(() => {
    setSummarizedAC(summarized_ac);
  }, [summarized_ac]);

  useEffect(() => {
    setFootPrint(foot_print);
  }, [foot_print]);

  useEffect(() => {
    setFixedCost(fixed_cost);
  }, [fixed_cost]);

  useEffect(() => {
    setModuleDCCost(module_dc_cost);
  }, [module_dc_cost]);

  useEffect(() => {
    setRackA(rack_a_finance);
  }, [rack_a_finance]);

  useEffect(() => {
    setRackB(rack_b_finance);
  }, [rack_b_finance]);

  useEffect(() => {
    setRackC(rack_c_finance);
  }, [rack_c_finance]);

  useEffect(() => {
    setBosOther(bos_other);
  }, [bos_other]);

  useEffect(() => {
    setInverterInput(inverter_cost);
  }, [inverter_cost]);

  useEffect(() => {
    setAcAux(ac_aux);
  }, [ac_aux]);

  useEffect(() => {
    setMvWire(mv_wire);
  }, [mv_wire]);

  useEffect(() => {
    setOtherAC(other_ac);
  }, [other_ac]);

  useEffect(() => {
    setInterconnectionInput(interconnection);
  }, [interconnection]);

  useEffect(() => {
    setPermitsFees(permits_fees);
  }, [permits_fees]);

  useEffect(() => {
    setEngineeringInput(engineering);
  }, [engineering]);

  useEffect(() => {
    setMarginInput(margin);
  }, [margin]);

  useEffect(() => {
    setitcIneligible(itc_ineligible);
  }, [itc_ineligible]);

  useEffect(() => {
    setOtherFixed(other_fixed);
  }, [other_fixed]);

  useEffect(() => {
    setRackFootprint(rack_footprint);
  }, [rack_footprint]);

  useEffect(() => {
    // don't overwrite the field while the user is actively editing it
    if (!(isEditing_ref.current.editing && isEditing_ref.current.id === "boundary_area_per")) {
      setBoundaryArea(boundary_area_per);
    }
  }, [boundary_area_per]);

  useEffect(() => {
    if (!(isEditing_ref.current.editing && isEditing_ref.current.id === "contingency")) {
      setContingencyInput(contingency);
    }
  }, [contingency]);

  useEffect(() => {
    if (do_finance == false) {
      set_toggle_install_costs(false);
      set_toggle_dc_units(false);
      set_toggle_ac_units(false);
      set_toggle_fixed_cost(false);
      set_toggle_misc_cost(false);
      set_toggle_dc_wire(false);
    }
  }, [do_finance]);

  useEffect(() => {
    if (toggle_finance_type == 1) {
      set_toggle_dc_wire(false);
    }
  }, [toggle_finance_type]);

  useEffect(() => {
    calculateRackTotal();
  }, []);

  useEffect(() => {
    calculateRackTotal();
  }, [rack_a_finance, rack_b_finance, rack_c_finance]);

  const calculateRackTotal = () => {
    let rack_a_count = !rack_a_not_active ? rack_a_finance.total : 0;
    let rack_b_count = !rack_b_not_active ? rack_b_finance.total : 0;
    let rack_c_count = !rack_c_not_active ? rack_c_finance.total : 0;
    // set_active_rack_total(rack_a_count + rack_b_count + rack_c_count);
    set_active_rack_total(rack_a_count);
  };

  const toggleDCWire = () => {
    let pageHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    setPopoutY(Math.min(pageHeight - 444, pageHeight * 0.35));
    set_toggle_dc_wire(!toggle_dc_wire);
  };

  let spacing_gcr_data = [];
  let spacing_gcr_index = 0;

  let dc_wiring_data = [];
  let dc_wiring_index = 0;

  const financeType = [
    { label: "Summed", value: 0 },
    { label: "Detail", value: 1 },
  ];

  const updateTableInputs = (key, value) => {
    dispatch(inputsActions.update_input(key, value));
  };

  const updateInput = (key, value, notAnObject = false) => {
    if (notAnObject) {
      let decPart = (value + "").split(".")[1];
      if (decPart && decPart.slice(-1) == "0") return;
      let changed_value = parseFloat(value);
      if (!isNumber(changed_value)) return;
      dispatch(inputsActions.update_input(key, changed_value));
    } else {
      let decPart = (value.value + "").split(".")[1];
      if (decPart && decPart.slice(-1) == "0") return;
      let changed_value = { value: parseFloat(value.value), type: parseInt(value.type), total: parseFloat(value.total) };
      if (!isNumber(changed_value.value)) return;
      dispatch(inputsActions.update_input(key, changed_value));
    }
  };

  const makeItRain = (sum) => {
    return sum.toLocaleString();
  };

  const handleCreateSpacingAdder = () => {
    let dt_data = [
      [
        { value: "GCR", readOnly: true },
        { value: "$/Wp", readOnly: true },
      ],
    ];
    let data = { spacing_gcr, spacing_per_wp };
    let def = false;

    for (var index in data.spacing_gcr) {
      dt_data.push([
        { readOnly: false, value: data.spacing_gcr[index] },
        { readOnly: false, value: data.spacing_per_wp[index] },
        {
          readOnly: true,
          value: "",
          component: (
            <Tooltip placement="right" title="(Insert Below) / (Delete)" mouseEnterDelay={0.5}>
              <div style={{ width: 60 }}>
                <Button style={{ marginRight: 2, borderColor: "#ffffff" }} shape="circle" id={index} size="small" type="primary" ghost onClick={onInsertRow}>
                  <MenuFoldOutlined />
                </Button>
                <Button style={{ marginRight: 2, borderColor: "#ffffff" }} shape="circle" id={(parseInt(index) + 1) * 10} size="small" type="primary" ghost onClick={onRemoveRow}>
                  <MinusCircleOutlined />
                </Button>
              </div>
            </Tooltip>
          ),
          forceComponent: true,
        },
      ]);
    }

    if (data.spacing_gcr && data.spacing_gcr.length == 0) {
      dt_data.splice(1, 0, [
        { readOnly: def, value: 0 },
        { readOnly: def, value: 0 },
        {
          readOnly: true,
          value: "",
          component: (
            <Tooltip placement="right" title="(Insert Below) / (Delete)" mouseEnterDelay={0.5}>
              <div style={{ width: 60 }}>
                <Button style={{ marginRight: 2, borderColor: "#ffffff" }} shape="circle" id={0} size="small" type="primary" ghost onClick={onInsertRow}>
                  <MenuFoldOutlined />
                </Button>
                <Button style={{ marginRight: 2, borderColor: "#ffffff" }} shape="circle" id={10} size="small" type="primary" ghost onClick={onRemoveRow}>
                  <MinusCircleOutlined />
                </Button>
              </div>
            </Tooltip>
          ),
          forceComponent: true,
        },
      ]);
    }

    spacing_gcr_data = dt_data;
    spacing_gcr_index = index;
  };

  // const formatCurrency = (value) => {
  //   if (value === "" || isNaN(value)) return "";
  //   return Number(value).toLocaleString(undefined, {
  //     minimumFractionDigits: 2,
  //     maximumFractionDigits: 2,
  //   });
  // };

  const onInsertRow = (e) => {
    let event = Object.assign({}, e);
    let index = parseInt(event.currentTarget.id);
    let data = { spacing_gcr, spacing_per_wp };
    data.spacing_gcr.splice(index + 1, 0, 0);
    data.spacing_per_wp.splice(index + 1, 0, 0);
    updateTableInputs("spacing_gcr", data.spacing_gcr);
    updateTableInputs("spacing_per_wp", data.spacing_per_wp);
    handleCreateSpacingAdder();
  };

  const onRemoveRow = (e) => {
    let event = Object.assign({}, e);
    let data = { spacing_gcr, spacing_per_wp };
    if (data.spacing_gcr.length == 1) return;
    let index = event.currentTarget.id / 10 - 1;
    data.spacing_gcr.splice(index, 1);
    data.spacing_per_wp.splice(index, 1);
    updateTableInputs("spacing_gcr", data.spacing_gcr);
    updateTableInputs("spacing_per_wp", data.spacing_per_wp);
    handleCreateSpacingAdder();
  };

  const handleChanges = (changes) => {
    const data = spacing_gcr_data.map((row) => [...row]);
    changes.forEach(({ cell, row, col, value }) => {
      if (data[row] && data[row][col]) {
        data[row][col] = { ...data[row][col], value };
      }
    });
    let newModData = data.slice(1, data.length);
    let GCR = [];
    let WP = [];
    newModData.forEach((row) => {
      let gcr = parseFloat(row[0].value) == row[0].value ? parseFloat(row[0].value) : 0;
      let wp = parseFloat(row[1].value) == row[1].value ? parseFloat(row[1].value) : 0;
      GCR.push(gcr);
      WP.push(wp);
    });

    updateTableInputs("spacing_gcr", GCR);
    updateTableInputs("spacing_per_wp", WP);
  };

  const handleDCChanges = (changes) => {
    const data = dc_wiring_data.map((row) => [...row]);
    changes.forEach(({ cell, row, col, value }) => {
      if (data[row] && data[row][col]) {
        data[row][col] = { ...data[row][col], value };
      }
    });
    let newModData = data.slice(1, data.length);
    let dc_gcr = [];
    let dc_wp = [];
    newModData.forEach((row) => {
      let gcr = parseFloat(row[0].value) == row[0].value ? parseFloat(row[0].value) : 0;
      let wp = parseFloat(row[1].value) == row[1].value ? parseFloat(row[1].value) : 0;
      dc_gcr.push(gcr);
      dc_wp.push(wp);
    });

    updateTableInputs("summarized_dc_wiring_gcr", dc_gcr);
    updateTableInputs("summarized_dc_wiring_wp", dc_wp);
  };

  // toggle_finance_type == 1 ? handleCreateSpacingAdder() : handleCreateDCWireTable();
  handleCreateSpacingAdder();

  useEffect(() => {
    console.log("sum", fixedCost);
  }, [fixedCost]);
  return (
    <>
      <TitleDivider title="Install Costs" collapseable={true} toggle_var={toggle_install_costs} toggle_fn={set_toggle_install_costs} />

      {toggle_install_costs && (
        <>
          <section className="input-row-two-col">
            <label>Cost Breakdown</label>
            <Radio.Group
              className="finance-install-cost-radios"
              style={{ marginLeft: "auto" }}
              name="toggle_finance_type"
              options={financeType}
              onChange={(e) => {
                updateInput(e.target.name, e.target.value, true);
              }}
              value={toggle_finance_type}
              disabled={account_loading || input_loading}
            />
          </section>

          {toggle_finance_type == 0 ? (
            <>
              <section className="input-row-two-col">
                <label>DC</label>
                <Input
                  id="summarized_dc"
                  style={{ maxWidth: 135, marginLeft: "auto" }}
                  size="small"
                  type="text"
                  autoComplete="off"
                  disabled={account_loading || input_loading}
                  value={isEditing.id === "summarized_dc" && isEditing.editing === true ? summarizedDC : formatCurrency(summarizedDC)}
                  onFocus={() => setIsEditing({ id: "summarized_dc", editing: true })}
                  onChange={(e) => {
                    const newVal = e.target.value;
                    if (/^[\d,.]*$/.test(newVal)) {
                      setSummarizedDC(newVal);
                    }
                  }}
                  onBlur={(e) => {
                    const raw = e.target.value.replace(/,/g, "");
                    const parsed = parseFloat(raw);
                    const validValue = isNaN(parsed) ? 0 : parsed;
                    setSummarizedDC(validValue);
                    updateInput(e.target.id, validValue, true);
                    setIsEditing({ id: undefined, editing: false });
                  }}
                />
              </section>

              {/* <section className="input-row-two-col">
                <label>DC Wire</label>
                <a style={{ marginLeft: "auto" }} onClick={toggleDCWire}>
                  {toggle_dc_wire ? "Close DC Wire Table" : "Open DC Wire Table "}
                </a>
              </section> */}

              <section className="input-row-two-col">
                <label>AC</label>
                <Input
                  id="summarized_ac"
                  style={{ maxWidth: 135, marginLeft: "auto" }}
                  size="small"
                  type="text"
                  autoComplete="off"
                  disabled={account_loading || input_loading}
                  suffix={<span style={{ color: "rgba(0,0,0,.45)" }}>$/Wac</span>}
                  value={isEditing.id === "summarized_ac" && isEditing.editing === true ? summarizedAC : formatCurrency(summarizedAC)}
                  onFocus={() => setIsEditing({ id: "summarized_ac", editing: true })}
                  onChange={(e) => {
                    const newVal = e.target.value;
                    if (/^[\d,.]*$/.test(newVal)) {
                      setSummarizedAC(newVal);
                    }
                  }}
                  onBlur={(e) => {
                    const raw = e.target.value.replace(/,/g, "");
                    const parsed = parseFloat(raw);
                    const validValue = isNaN(parsed) ? 0 : parsed;
                    setSummarizedAC(validValue);
                    updateInput(e.target.id, validValue, true);
                    setIsEditing({ id: undefined, editing: false });
                  }}
                />
              </section>

              {/* <section className="input-row-two-col">
                <label>Footprint</label>
                <Input
                  id="foot_print"
                  style={{ maxWidth: 135, marginLeft: "auto" }}
                  size="small"
                  min="0"
                  type="number"
                  step="0.01"
                  autoComplete="off"
                  disabled={account_loading || input_loading}
                  value={footPrint}
                  suffix={<span style={{ color: "rgba(0,0,0,.45)" }}>$/ha</span>}
                  onChange={(e) => {
                    setFootPrint(e.target.value);
                    updateInput(e.target.id, e.target.value, true);
                  }}
                />
              </section> */}

              <section className="input-row-two-col">
                <label>Fixed Costs</label>
                <Input
                  id="fixed_cost"
                  style={{ maxWidth: 135, marginLeft: "auto" }}
                  size="small"
                  type="text"
                  autoComplete="off"
                  disabled={account_loading || input_loading}
                  suffix={<span style={{ color: "rgba(0,0,0,.45)" }}>$</span>}
                  value={isEditing.id === "fixed_cost" && isEditing.editing === true ? fixedCost : formatCurrency(fixedCost)}
                  onFocus={() => setIsEditing({ id: "fixed_cost", editing: true })}
                  onChange={(e) => {
                    const newVal = e.target.value;
                    if (/^[\d,.]*$/.test(newVal)) {
                      setFixedCost(newVal);
                    }
                  }}
                  onBlur={(e) => {
                    const raw = e.target.value.replace(/,/g, "");
                    const parsed = parseFloat(raw);
                    const validValue = isNaN(parsed) ? 0 : parsed;
                    setFixedCost(validValue);
                    updateInput(e.target.id, validValue, true);
                    setIsEditing({ id: undefined, editing: false });
                  }}
                />
              </section>

              {/* <section className="input-row-two-col">
								<label>Spacing Adders</label>
							</section>
							<section style={{ float: "left", width: 180, marginBottom: "16px" }}>
								<ReactDataSheet
									data={spacing_gcr_data}
									sheetRenderer={renderSheet}
									valueRenderer={(cell) => cell.value}
									onContextMenu={(e, cell, i, j) => (cell.readOnly ? e.preventDefault() : null)}
									onCellsChanged={handleChanges}
								/>
							</section>							 */}

              {/* <section className="input-row-two-col">
                <p>Total</p>
                <p style={{ marginLeft: 25 }}>{`$${makeItRain(summarized_dc + summarized_ac + foot_print + fixed_cost)}`}</p>
              </section> */}

              {/* <InputPopout visible={toggle_dc_wire} onClose={toggleDCWire} popoutY={popoutY}>
                <DCWireWrapper>
                  <label>DC Wire Table</label>
                  <section className="dc-table">
                    <ReactDataSheet
                      data={dc_wiring_data}
                      sheetRenderer={renderSheet}
                      valueRenderer={(cell) => cell.value}
                      onContextMenu={(e, cell, i, j) => (cell.readOnly ? e.preventDefault() : null)}
                      onCellsChanged={handleDCChanges}
                    />
                  </section>
                </DCWireWrapper>
              </InputPopout> */}
            </>
          ) : (
            <>
              {/* DC Units */}
              <TitleDivider title="DC Units" collapseable={true} toggle_var={toggle_dc_units} toggle_fn={set_toggle_dc_units} subHeader={true} />
              {toggle_dc_units && (
                <>
                  <section className="input-row-three-col">
                    <label>Module</label>
                    <Input
                      id="module_dc_cost"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      type="text"
                      suffix={<span style={{ color: "rgba(0,0,0,.45)" }}>$</span>}
                      value={isEditing.id === "module_dc_cost" && isEditing.editing === true ? moduleDCCost.value : formatCurrency(moduleDCCost.value)}
                      onFocus={() => setIsEditing({ id: "module_dc_cost", editing: true })}
                      onChange={(e) => {
                        const newVal = e.target.value;
                        if (/^[\d,.]*$/.test(newVal)) {
                          setModuleDCCost((prev) => ({
                            ...prev,
                            value: newVal.replace(/,/g, ""),
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        const parsed = parseFloat(raw);
                        const validValue = isNaN(parsed) ? 0 : parsed;

                        setModuleDCCost({
                          value: validValue.toString(),
                          type: moduleDCCost.type,
                          total: moduleDCCost.total,
                        });

                        updateInput(e.target.id, {
                          value: validValue,
                          type: moduleDCCost.type,
                          total: moduleDCCost.total,
                        });

                        setIsEditing({ id: undefined, editing: false });
                      }}
                    />

                    <FinanceSelectMenu type="dc_module" id="module_dc_cost" />
                  </section>

                  <Tooltip placement="top" title={rack_a_not_active ? "Rack A is Off" : ""} mouseEnterDelay={0.5}>
                    <section className="input-row-three-col">
                      <label>Rack A</label>
                      <Input
                        id="rack_a_finance"
                        style={{ maxWidth: 135, marginLeft: "auto" }}
                        size="small"
                        type="text"
                        autoComplete="off"
                        disabled={account_loading || input_loading || rack_a_not_active}
                        value={isEditing.id === "rack_a_finance" && isEditing.editing === true ? rackA.value : formatCurrency(rackA.value)}
                        onFocus={() => setIsEditing({ id: "rack_a_finance", editing: true })}
                        onChange={(e) => {
                          const newVal = e.target.value;
                          if (/^[\d,.]*$/.test(newVal)) {
                            setRackA((prev) => ({
                              ...prev,
                              value: newVal.replace(/,/g, ""),
                            }));
                          }
                        }}
                        onBlur={(e) => {
                          const raw = e.target.value.replace(/,/g, "");
                          const parsed = parseFloat(raw);
                          const validValue = isNaN(parsed) ? 0 : parsed;

                          setRackA({
                            value: validValue.toString(),
                            type: rackA.type,
                            total: rackA.total,
                          });

                          updateInput(e.target.id, {
                            value: validValue,
                            type: rackA.type,
                            total: rackA.total,
                          });

                          setIsEditing({ id: undefined, editing: false });
                        }}
                      />
                      <FinanceSelectMenu type="dc" id="rack_a_finance" disabled={rack_a_not_active} />
                    </section>
                  </Tooltip>

                  <Tooltip placement="top" title={rack_b_not_active ? "Rack B is Off" : ""} mouseEnterDelay={0.5}>
                    <section className="input-row-three-col">
                      <label>Rack B</label>
                      <Input
                        id="rack_b_finance"
                        style={{ maxWidth: 135, marginLeft: "auto" }}
                        size="small"
                        type="text"
                        autoComplete="off"
                        disabled={account_loading || input_loading || rack_b_not_active}
                        value={isEditing.id === "rack_b_finance" && isEditing.editing === true ? rackB.value : formatCurrency(rackB.value)}
                        onFocus={() => setIsEditing({ id: "rack_b_finance", editing: true })}
                        onChange={(e) => {
                          const newVal = e.target.value;
                          if (/^[\d,.]*$/.test(newVal)) {
                            setRackB((prev) => ({
                              ...prev,
                              value: newVal.replace(/,/g, ""),
                            }));
                          }
                        }}
                        onBlur={(e) => {
                          const raw = e.target.value.replace(/,/g, "");
                          const parsed = parseFloat(raw);
                          const validValue = isNaN(parsed) ? 0 : parsed;

                          setRackB({
                            value: validValue.toString(),
                            type: rackB.type,
                            total: rackB.total,
                          });

                          updateInput(e.target.id, {
                            value: validValue,
                            type: rackB.type,
                            total: rackB.total,
                          });

                          setIsEditing({ id: undefined, editing: false });
                        }}
                      />
                      <FinanceSelectMenu type="dc" id="rack_b_finance" disabled={rack_b_not_active} />
                    </section>
                  </Tooltip>

                  <Tooltip placement="top" title={rack_c_not_active ? "Rack C is Off" : ""} mouseEnterDelay={0.5}>
                    <section className="input-row-three-col">
                      <label>Rack C</label>
                      <Input
                        id="rack_c_finance"
                        style={{ maxWidth: 135, marginLeft: "auto" }}
                        size="small"
                        type="text"
                        autoComplete="off"
                        disabled={account_loading || input_loading || rack_c_not_active}
                        value={isEditing.id === "rack_c_finance" && isEditing.editing === true ? rackC.value : formatCurrency(rackC.value)}
                        onFocus={() => setIsEditing({ id: "rack_c_finance", editing: true })}
                        onChange={(e) => {
                          const newVal = e.target.value;
                          if (/^[\d,.]*$/.test(newVal)) {
                            setRackC((prev) => ({
                              ...prev,
                              value: newVal.replace(/,/g, ""),
                            }));
                          }
                        }}
                        onBlur={(e) => {
                          const raw = e.target.value.replace(/,/g, "");
                          const parsed = parseFloat(raw);
                          const validValue = isNaN(parsed) ? 0 : parsed;

                          setRackC({
                            value: validValue.toString(),
                            type: rackC.type,
                            total: rackC.total,
                          });

                          updateInput(e.target.id, {
                            value: validValue,
                            type: rackC.type,
                            total: rackC.total,
                          });

                          setIsEditing({ id: undefined, editing: false });
                        }}
                      />
                      <FinanceSelectMenu type="dc" id="rack_c_finance" disabled={rack_c_not_active} />
                    </section>
                  </Tooltip>

                  <section className="input-row-three-col">
                    <label>BOS Other</label>
                    <Input
                      id="bos_other"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      type="text"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      // suffix={<span style={{ color: "rgba(0,0,0,.45)" }}>$/Wp</span>}
                      value={isEditing.id === "bos_other" && isEditing.editing === true ? bosOther.value : formatCurrency(bosOther.value)}
                      onFocus={() => setIsEditing({ id: "bos_other", editing: true })}
                      onChange={(e) => {
                        const newVal = e.target.value;
                        if (/^[\d,.]*$/.test(newVal)) {
                          setBosOther((prev) => ({
                            ...prev,
                            value: newVal.replace(/,/g, ""),
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        const parsed = parseFloat(raw);
                        const validValue = isNaN(parsed) ? 0 : parsed;

                        setBosOther({
                          value: validValue.toString(),
                          type: bosOther.type,
                          total: bosOther.total,
                        });

                        updateInput(e.target.id, {
                          value: validValue,
                          type: bosOther.type,
                          total: bosOther.total,
                        });

                        setIsEditing({ id: undefined, editing: false });
                      }}
                    />
                    <FinanceSelectMenu type="wp_only" id="bos_other" />

                    {/* <Input
                      id="bos_other"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      min="0"
                      type="number"
                      step="0.01"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      value={bosOther.value}
                      onChange={(e) => {
                        setBosOther({ value: e.target.value, type: bos_other.type, total: bos_other.total });
                        updateInput(e.target.id, { value: e.target.value, type: bos_other.type, total: bos_other.total });
                      }}
                    />
                    <FinanceSelectMenu type="wp_only" id="bos_other" /> */}
                  </section>

                  <section className="total-row">
                    <p>Total DC</p>
                    <p>{`${makeItRain(module_dc_cost.total + active_rack_total + bos_other.total)} $/Wp`}</p>
                  </section>
                </>
              )}

              {/* AC Units */}
              <TitleDivider title="AC Units" collapseable={true} toggle_var={toggle_ac_units} toggle_fn={set_toggle_ac_units} subHeader={true} />

              {toggle_ac_units && (
                <>
                  <section className="input-row-three-col">
                    <label>Inverter</label>
                    <Input
                      id="inverter_cost"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      type="text"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      value={isEditing.id === "inverter_cost" && isEditing.editing === true ? inverterInput.value : formatCurrency(inverterInput.value)}
                      onFocus={() => setIsEditing({ id: "inverter_cost", editing: true })}
                      onChange={(e) => {
                        const newVal = e.target.value;
                        if (/^[\d,.]*$/.test(newVal)) {
                          setInverterInput((prev) => ({
                            ...prev,
                            value: newVal.replace(/,/g, ""),
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        const parsed = parseFloat(raw);
                        const validValue = isNaN(parsed) ? 0 : parsed;

                        setInverterInput({
                          value: validValue.toString(),
                          type: inverterInput.type,
                          total: inverterInput.total,
                        });

                        updateInput(e.target.id, {
                          value: validValue,
                          type: inverterInput.type,
                          total: inverterInput.total,
                        });

                        setIsEditing({ id: undefined, editing: false });
                      }}
                    />
                    <FinanceSelectMenu type="ac_inverter" id="inverter_cost" />
                  </section>

                  <section className="input-row-three-col">
                    <label>AC Aux</label>
                    <Input
                      id="ac_aux"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      type="text"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      value={isEditing.id === "ac_aux" && isEditing.editing === true ? acAux.value : formatCurrency(acAux.value)}
                      onFocus={() => setIsEditing({ id: "ac_aux", editing: true })}
                      onChange={(e) => {
                        const newVal = e.target.value;
                        if (/^[\d,.]*$/.test(newVal)) {
                          setAcAux((prev) => ({
                            ...prev,
                            value: newVal.replace(/,/g, ""),
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        const parsed = parseFloat(raw);
                        const validValue = isNaN(parsed) ? 0 : parsed;

                        setAcAux({
                          value: validValue.toString(),
                          type: acAux.type,
                          total: acAux.total,
                        });

                        updateInput(e.target.id, {
                          value: validValue,
                          type: acAux.type,
                          total: acAux.total,
                        });

                        setIsEditing({ id: undefined, editing: false });
                      }}
                    />
                    <FinanceSelectMenu type="ac" id="ac_aux" />
                  </section>

                  <section className="input-row-three-col">
                    <label>MV Wire</label>
                    <Input
                      id="mv_wire"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      type="text"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      value={isEditing.id === "mv_wire" && isEditing.editing === true ? mvWire.value : formatCurrency(mvWire.value)}
                      onFocus={() => setIsEditing({ id: "mv_wire", editing: true })}
                      onChange={(e) => {
                        const newVal = e.target.value;
                        if (/^[\d,.]*$/.test(newVal)) {
                          setMvWire((prev) => ({
                            ...prev,
                            value: newVal.replace(/,/g, ""),
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        const parsed = parseFloat(raw);
                        const validValue = isNaN(parsed) ? 0 : parsed;

                        setMvWire({
                          value: validValue.toString(),
                          type: mvWire.type,
                          total: mvWire.total,
                        });

                        updateInput(e.target.id, {
                          value: validValue,
                          type: mvWire.type,
                          total: mvWire.total,
                        });

                        setIsEditing({ id: undefined, editing: false });
                      }}
                    />
                    <FinanceSelectMenu type="wac_only" id="mv_wire" />
                  </section>

                  <section className="input-row-three-col">
                    <label>Other AC</label>
                    <Input
                      id="other_ac"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      type="text"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      value={isEditing.id === "other_ac" && isEditing.editing === true ? otherAC.value : formatCurrency(otherAC.value)}
                      onFocus={() => setIsEditing({ id: "other_ac", editing: true })}
                      onChange={(e) => {
                        const newVal = e.target.value;
                        if (/^[\d,.]*$/.test(newVal)) {
                          setOtherAC((prev) => ({
                            ...prev,
                            value: newVal.replace(/,/g, ""),
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        const parsed = parseFloat(raw);
                        const validValue = isNaN(parsed) ? 0 : parsed;

                        setOtherAC({
                          value: validValue.toString(),
                          type: otherAC.type,
                          total: otherAC.total,
                        });

                        updateInput(e.target.id, {
                          value: validValue,
                          type: otherAC.type,
                          total: otherAC.total,
                        });

                        setIsEditing({ id: undefined, editing: false });
                      }}
                    />
                    <FinanceSelectMenu type="wac_only" id="other_ac" />
                  </section>
                  <section className="total-row">
                    <p>Total AC</p>
                    <p>{`${makeItRain(inverter_cost.total + ac_aux.total + mv_wire.total + other_ac.total)} $/Wac`}</p>
                  </section>
                </>
              )}
              {/* Fixed Units */}
              <TitleDivider title="Fixed Units" collapseable={true} toggle_var={toggle_fixed_cost} toggle_fn={set_toggle_fixed_cost} subHeader={true} />
              {toggle_fixed_cost && (
                <>
                  <section className="input-row-two-col">
                    <label>Interconnect</label>
                    <Input
                      id="interconnection"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      type="text"
                      value={isEditing.id === "interconnection" && isEditing.editing === true ? interconnectionInput.value : formatCurrency(interconnectionInput.value)}
                      onFocus={() => setIsEditing({ id: "interconnection", editing: true })}
                      onChange={(e) => {
                        const newVal = e.target.value;
                        if (/^[\d,.]*$/.test(newVal)) {
                          setInterconnectionInput((prev) => ({
                            ...prev,
                            value: newVal.replace(/,/g, ""),
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        const parsed = parseFloat(raw);
                        const validValue = isNaN(parsed) ? 0 : parsed;

                        setInterconnectionInput({
                          value: validValue.toString(),
                          type: interconnection.type,
                          total: interconnection.total,
                        });

                        updateInput(e.target.id, {
                          value: validValue,
                          type: interconnection.type,
                          total: interconnection.total,
                        });

                        setIsEditing({ id: undefined, editing: false });
                      }}
                    />

                    {/* <Input
                      id="interconnection"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      min="0"
                      type="number"
                      step="0.01"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      value={interconnectionInput.value}
                      suffix={<span style={{ color: "rgba(0,0,0,.45)" }}>$</span>}
                      onBlur={(e) => {
                        if (interconnectionInput.value == "") {
                          setInterconnectionInput({ value: 0, type: interconnection.type, total: interconnection.total });
                          updateInput(e.target.id, { value: 0, type: interconnection.type, total: interconnection.total });
                        }
                      }}
                      onChange={(e) => {
                        setInterconnectionInput({ value: e.target.value, type: interconnection.type, total: interconnection.total });
                        updateInput(e.target.id, { value: e.target.value, type: interconnection.type, total: interconnection.total });
                      }}
                    /> */}

                    {/* <Input
                      id="interconnection"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      min="0"
                      type="number"
                      step="0.01"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      value={interconnectionInput.value}
                      onChange={(e) => {
                        setInterconnectionInput({ value: e.target.value, type: interconnection.type, total: interconnection.total });
                        updateInput(e.target.id, { value: e.target.value, type: interconnection.type, total: interconnection.total });
                      }}
                    />
                    <FinanceSelectMenu type="fixed" id="interconnection" /> */}
                  </section>

                  <section className="input-row-two-col">
                    <label>Permits, Fees</label>
                    <Input
                      id="permits_fees"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      type="text"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      suffix={<span style={{ color: "rgba(0,0,0,.45)" }}>$</span>}
                      value={isEditing.id === "permits_fees" && isEditing.editing === true ? permitsFees.value : formatCurrency(permitsFees.value)}
                      onFocus={() => setIsEditing({ id: "permits_fees", editing: true })}
                      onChange={(e) => {
                        const newVal = e.target.value;
                        if (/^[\d,.]*$/.test(newVal)) {
                          setPermitsFees((prev) => ({
                            ...prev,
                            value: newVal.replace(/,/g, ""),
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        const parsed = parseFloat(raw);
                        const validValue = isNaN(parsed) ? 0 : parsed;

                        setPermitsFees({
                          value: validValue.toString(),
                          type: permitsFees.type,
                          total: permitsFees.total,
                        });

                        updateInput(e.target.id, {
                          value: validValue,
                          type: permitsFees.type,
                          total: permitsFees.total,
                        });

                        setIsEditing({ id: undefined, editing: false });
                      }}
                    />

                    {/* <Input
                      id="permits_fees"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      min="0"
                      type="number"
                      step="0.01"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      value={permitsFees.value}
                      onChange={(e) => {
                        setPermitsFees({ value: e.target.value, type: permits_fees.type, total: permits_fees.total });
                        updateInput(e.target.id, { value: e.target.value, type: permits_fees.type, total: permits_fees.total });
                      }}
                    />
                    <FinanceSelectMenu type="fixed" id="permits_fees" /> */}
                  </section>

                  <section className="input-row-two-col">
                    <label>Engineering</label>
                    <Input
                      id="engineering"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      type="text"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      suffix={<span style={{ color: "rgba(0,0,0,.45)" }}>$</span>}
                      value={isEditing.id === "engineering" && isEditing.editing === true ? engineeringInput.value : formatCurrency(engineeringInput.value)}
                      onFocus={() => setIsEditing({ id: "engineering", editing: true })}
                      onChange={(e) => {
                        const newVal = e.target.value;
                        if (/^[\d,.]*$/.test(newVal)) {
                          setEngineeringInput((prev) => ({
                            ...prev,
                            value: newVal.replace(/,/g, ""),
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        const parsed = parseFloat(raw);
                        const validValue = isNaN(parsed) ? 0 : parsed;

                        setEngineeringInput({
                          value: validValue.toString(),
                          type: engineeringInput.type,
                          total: engineeringInput.total,
                        });

                        updateInput(e.target.id, {
                          value: validValue,
                          type: engineeringInput.type,
                          total: engineeringInput.total,
                        });

                        setIsEditing({ id: undefined, editing: false });
                      }}
                    />

                    {/* <Input
                      id="engineering"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      min="0"
                      type="number"
                      step="0.01"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      value={engineeringInput.value}
                      onChange={(e) => {
                        setEngineeringInput({ value: e.target.value, type: engineering.type, total: engineering.total });
                        updateInput(e.target.id, { value: e.target.value, type: engineering.type, total: engineering.total });
                      }}
                    />
                    <FinanceSelectMenu type="fixed" id="engineering" /> */}
                  </section>

                  <section className="input-row-two-col">
                    <label>Margin</label>
                    <Input
                      id="margin"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      type="text"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      suffix={<span style={{ color: "rgba(0,0,0,.45)" }}>$</span>}
                      value={isEditing.id === "margin" && isEditing.editing === true ? marginInput.value : formatCurrency(marginInput.value)}
                      onFocus={() => setIsEditing({ id: "margin", editing: true })}
                      onChange={(e) => {
                        const newVal = e.target.value;
                        if (/^[\d,.]*$/.test(newVal)) {
                          setMarginInput((prev) => ({
                            ...prev,
                            value: newVal.replace(/,/g, ""),
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        const parsed = parseFloat(raw);
                        const validValue = isNaN(parsed) ? 0 : parsed;

                        setMarginInput({
                          value: validValue.toString(),
                          type: marginInput.type,
                          total: marginInput.total,
                        });

                        updateInput(e.target.id, {
                          value: validValue,
                          type: marginInput.type,
                          total: marginInput.total,
                        });

                        setIsEditing({ id: undefined, editing: false });
                      }}
                    />
                    {/* <Input
                      id="margin"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      min="0"
                      type="number"
                      step="0.01"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      value={marginInput.value}
                      onChange={(e) => {
                        setMarginInput({ value: e.target.value, type: margin.type, total: margin.total });
                        updateInput(e.target.id, { value: e.target.value, type: margin.type, total: margin.total });
                      }}
                    />
                    <FinanceSelectMenu type="fixed" id="margin" /> */}
                  </section>
                  <section className="input-row-two-col">
                    <label>ITC Ineligible</label>
                    <Input
                      id="itc_ineligible"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      type="text"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      suffix={<span style={{ color: "rgba(0,0,0,.45)" }}>$</span>}
                      value={isEditing.id === "itc_ineligible" && isEditing.editing === true ? itcIneligible.value : formatCurrency(itcIneligible.value)}
                      onFocus={() => setIsEditing({ id: "itc_ineligible", editing: true })}
                      onChange={(e) => {
                        const newVal = e.target.value;
                        if (/^[\d,.]*$/.test(newVal)) {
                          setitcIneligible((prev) => ({
                            ...prev,
                            value: newVal.replace(/,/g, ""),
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        const parsed = parseFloat(raw);
                        const validValue = isNaN(parsed) ? 0 : parsed;

                        setitcIneligible({
                          value: validValue.toString(),
                          type: itcIneligible.type,
                          total: itcIneligible.total,
                        });

                        updateInput(e.target.id, {
                          value: validValue,
                          type: itcIneligible.type,
                          total: itcIneligible.total,
                        });

                        setIsEditing({ id: undefined, editing: false });
                      }}
                    />
                  </section>

                  <section className="input-row-two-col">
                    <label>Other Fixed</label>
                    <Input
                      id="other_fixed"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      type="text"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      suffix={<span style={{ color: "rgba(0,0,0,.45)" }}>$</span>}
                      value={isEditing.id === "other_fixed" && isEditing.editing === true ? otherFixed.value : formatCurrency(otherFixed.value)}
                      onFocus={() => setIsEditing({ id: "other_fixed", editing: true })}
                      onChange={(e) => {
                        const newVal = e.target.value;
                        if (/^[\d,.]*$/.test(newVal)) {
                          setOtherFixed((prev) => ({
                            ...prev,
                            value: newVal.replace(/,/g, ""),
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        const parsed = parseFloat(raw);
                        const validValue = isNaN(parsed) ? 0 : parsed;

                        setOtherFixed({
                          value: validValue.toString(),
                          type: otherFixed.type,
                          total: otherFixed.total,
                        });

                        updateInput(e.target.id, {
                          value: validValue,
                          type: otherFixed.type,
                          total: otherFixed.total,
                        });

                        setIsEditing({ id: undefined, editing: false });
                      }}
                    />
                    {/* <Input
                      id="other_fixed"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      min="0"
                      type="number"
                      step="0.01"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      value={otherFixed.value}
                      onChange={(e) => {
                        setOtherFixed({ value: e.target.value, type: other_fixed.type, total: other_fixed.total });
                        updateInput(e.target.id, { value: e.target.value, type: other_fixed.type, total: other_fixed.total });
                      }}
                    />
                    <FinanceSelectMenu type="fixed" id="other_fixed" /> */}
                  </section>

                  <section className="total-row">
                    <p>Total Fixed</p>
                    <p style={{ marginLeft: 95 }}>{`$${makeItRain(interconnection.value + permits_fees.value + engineering.value + margin.value + other_fixed.value + itc_ineligible.value)}`}</p>
                  </section>
                </>
              )}

              {/* Misc Units */}
              <TitleDivider title="Misc. Units" collapseable={true} toggle_var={toggle_misc_cost} toggle_fn={set_toggle_misc_cost} subHeader={true} />
              {toggle_misc_cost && (
                <>
                  <section className="input-row-three-col">
                    <label>Rack Footprint</label>
                    <Input
                      id="rack_footprint"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      type="text"
                      // prevent third-party grammar/completion extensions from attaching
                      data-gramm="false"
                      spellCheck={false}
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      value={isEditing.id === "rack_footprint" && isEditing.editing === true ? rackFootprint.value : formatCurrency(rackFootprint.value)}
                      onFocusCapture={(e) => {
                        // stop propagation so browser extension content scripts that listen to document focusin
                        // don't receive this event and error. We still set local editing state afterwards.
                        try {
                          e.stopPropagation();
                          if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) e.nativeEvent.stopImmediatePropagation();
                        } catch (err) {}
                        setIsEditing({ id: "rack_footprint", editing: true });
                      }}
                      onChange={(e) => {
                        const newVal = e.target.value;
                        if (/^[\d,.]*$/.test(newVal)) {
                          setRackFootprint((prev) => ({
                            ...prev,
                            value: newVal.replace(/,/g, ""),
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        const parsed = parseFloat(raw);
                        const validValue = isNaN(parsed) ? 0 : parsed;

                        setRackFootprint({
                          value: validValue.toString(),
                          type: rackFootprint.type,
                          total: rackFootprint.total,
                        });

                        updateInput(e.target.id, {
                          value: validValue,
                          type: rackFootprint.type,
                          total: rackFootprint.total,
                        });

                        setIsEditing({ id: undefined, editing: false });
                      }}
                    />
                    <FinanceSelectMenu type="misc" id="rack_footprint" />
                  </section>

                  <section className="input-row-three-col">
                    <label>Buildable Area</label>
                    <Input
                      id="boundary_area_per"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      type="text"
                      data-gramm="false"
                      spellCheck={false}
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      value={isEditing.id === "boundary_area_per" && isEditing.editing === true ? boundaryArea.value : formatCurrency(boundaryArea.value)}
                      onFocusCapture={(e) => {
                        try {
                          e.stopPropagation();
                          if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) e.nativeEvent.stopImmediatePropagation();
                        } catch (err) {}
                        setIsEditing({ id: "boundary_area_per", editing: true });
                      }}
                      onChange={(e) => {
                        const newVal = e.target.value;
                        if (/^[\d,.]*$/.test(newVal)) {
                          setBoundaryArea((prev) => ({
                            ...prev,
                            value: newVal.replace(/,/g, ""),
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        const parsed = parseFloat(raw);
                        const validValue = isNaN(parsed) ? 0 : parsed;

                        setBoundaryArea({
                          value: validValue.toString(),
                          type: boundaryArea.type,
                          total: boundaryArea.total,
                        });

                        updateInput(e.target.id, {
                          value: validValue,
                          type: boundaryArea.type,
                          total: boundaryArea.total,
                        });

                        setIsEditing({ id: undefined, editing: false });
                      }}
                    />
                    <FinanceSelectMenu type="misc" id="boundary_area_per" />
                  </section>

                  <section className="input-row-three-col">
                    <label>Contingency</label>
                    <Input
                      id="contingency"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      min="0"
                      type="text"
                      step="1"
                      data-gramm="false"
                      spellCheck={false}
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      value={isEditing.id === "contingency" && isEditing.editing === true ? contingencyInput.value : formatCurrency(contingencyInput.value)}
                      onFocusCapture={(e) => {
                        try {
                          e.stopPropagation();
                          if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) e.nativeEvent.stopImmediatePropagation();
                        } catch (err) {}
                        setIsEditing({ id: "contingency", editing: true });
                      }}
                      onChange={(e) => {
                        const newVal = e.target.value;
                        if (/^[\d,.]*$/.test(newVal)) {
                          setContingencyInput((prev) => ({
                            ...prev,
                            value: newVal.replace(/,/g, ""),
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        const parsed = parseFloat(raw);
                        const validValue = isNaN(parsed) ? 0 : parsed;

                        setContingencyInput({
                          value: validValue.toString(),
                          type: contingencyInput.type,
                          total: contingencyInput.total,
                        });

                        updateInput(e.target.id, {
                          value: validValue,
                          type: contingencyInput.type,
                          total: contingencyInput.total,
                        });

                        setIsEditing({ id: undefined, editing: false });
                      }}
                    />
                    <FinanceSelectMenu type="contingency" id="contingency" />
                    {/* <Input
                      id="contingency"
                      style={{ maxWidth: 135, marginLeft: "auto" }}
                      size="small"
                      min="0"
                      type="number"
                      step="0.01"
                      autoComplete="off"
                      disabled={account_loading || input_loading}
                      value={contingencyInput.value}
                      onChange={(e) => {
                        setContingencyInput({ value: e.target.value, type: contingency.type, total: contingency.total });
                        updateInput(e.target.id, { value: e.target.value, type: contingency.type, total: contingency.total });
                      }}
                    />
                    <FinanceSelectMenu type="contingency" id="contingency" /> */}
                  </section>

                  <section className="input-row-two-col">
                    <label>Spacing Adders</label>
                  </section>
                  <section style={{ float: "left", width: 180, marginBottom: "16px" }}>
                    <ReactDataSheet
                      data={spacing_gcr_data}
                      sheetRenderer={renderSheet}
                      valueRenderer={(cell) => cell.value}
                      onContextMenu={(e, cell, i, j) => (cell.readOnly ? e.preventDefault() : null)}
                      onCellsChanged={handleChanges}
                    />
                  </section>
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export { FinanceInstallCosts, formatCurrency };
